module.exports = __webpack_public_path__ + "static/media/renewal-unsuccessful.5fa7fa54.svg";